var moduleMap = {
	"./component": () => {
		return Promise.all(/* component */[__webpack_require__.e(4747), __webpack_require__.e(7029), __webpack_require__.e(6379), __webpack_require__.e(1795), __webpack_require__.e(1900), __webpack_require__.e(5578), __webpack_require__.e(9636), __webpack_require__.e(24), __webpack_require__.e(8744), __webpack_require__.e(6490)]).then(() => (() => ((__webpack_require__(66013)))));
	},
	"./component/quick-ai": () => {
		return Promise.all(/* quick-ai-service */[__webpack_require__.e(4747), __webpack_require__.e(7029), __webpack_require__.e(6379), __webpack_require__.e(1795), __webpack_require__.e(5578), __webpack_require__.e(9636), __webpack_require__.e(24), __webpack_require__.e(8744), __webpack_require__.e(5451)]).then(() => (() => ((__webpack_require__(9945)))));
	},
	"./component/dev-agent-chat": () => {
		return Promise.all(/* dev-agent-chat */[__webpack_require__.e(4747), __webpack_require__.e(7029), __webpack_require__.e(6379), __webpack_require__.e(5578), __webpack_require__.e(9636), __webpack_require__.e(24), __webpack_require__.e(2666)]).then(() => (() => ((__webpack_require__(19452)))));
	},
	"./fgKeys": () => {
		return __webpack_require__.e(/* aiFeatureGateKeys */ 9925).then(() => (() => ((__webpack_require__(8052)))));
	},
	"./quick-ai/contract": () => {
		return __webpack_require__.e(/* quick-ai-contract */ 9078).then(() => (() => ((__webpack_require__(91997)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});